'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { useEventCalendarView } from '@mui/x-scheduler-internals/use-event-calendar-view';
import { DayTimeGrid } from "../internals/components/day-time-grid/DayTimeGrid.mjs";
import { createDayTimeGridViewConfig } from "../internals/utils/day-time-grid-view-config.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const WEEK_VIEW_CONFIG = createDayTimeGridViewConfig(7);

/**
 * A Week View to use inside the Event Calendar.
 *
 * Renders the desktop event variant, which `DayTimeGrid` resolves from the default value of
 * `DayTimeGridInternalRenderersContext` — no provider is needed here.
 */
export const WeekView = /*#__PURE__*/React.memo(/*#__PURE__*/React.forwardRef(function WeekView(props, forwardedRef) {
  // Feature hooks
  const {
    days
  } = useEventCalendarView(WEEK_VIEW_CONFIG);
  return /*#__PURE__*/_jsx(DayTimeGrid, _extends({
    ref: forwardedRef,
    days: days
  }, props));
}));
if (process.env.NODE_ENV !== "production") WeekView.displayName = "WeekView";